export function getHeaderText(recordCount: number, scrollDownForMore: boolean) {
    if (scrollDownForMore) {
        return `${recordCount} records displayed. Scroll down for more.`;
    } else {
        return `${recordCount} records in total.`;
    }
}